import Defs from '../../../../includes/primitives/colorDefs'

export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.schedule = json.schedule
      this.chart    = json.chart
      this.header   = json.header
      this.table    = json.table
      this.columns  = json.columns
      this.sundries  = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters

      Defs.setDefs_Gradients(this.svg, 0, 'LinearA4', this.chart.color, [0.5, 1.5, 0.5, -0.3], this.localId)

      let x_ = 0
      this.columns.forEach((d, i)=> {
        if(i == this.columns.length-1) d.width = d.width + 10
        
        d.sx = x_
        d.mx = x_ + (d.width/2)
        
        if(d.align == 'start') d.tx = x_ + this.table.padding
        if(d.align == 'middle') d.tx = x_ + (d.width/2)
        if(d.align == 'end') d.tx = x_ + d.width - this.table.padding
        
        x_ = x_ + d.width
        d.ex = x_
      })

      this.header.width = x_
      this.header.depths = []
      let y_ = 0
      this.header.depth.forEach((d,i)=> {
        y_ = y_ + d
        this.header.depths[i] = y_
      })
      this.header.height = y_
      
      this.table.height = this.header.height + (this.rawData.length*this.table.lineHeight)

    },

  }
}